/**
 * WorkRoamerBrand.tsx
 * Official WorkRoamer™ brand asset — single source of truth.
 *
 * Renders the master brand PNG which contains:
 *   • Logo graphic (globe, silhouette, swoosh, map pin)
 *   • Wordmark ("Work" navy + "Roamer™" orange)
 *   • Tagline ("Where work finds you.")
 *
 * DO NOT render any additional wordmark or tagline text beside this component.
 * DO NOT wrap it in a box, border, rounded rectangle, or background panel.
 * DO NOT add shadows, glows, borders, or decorative frames.
 * DO NOT stretch, crop, distort, or recolor the PNG.
 * The PNG is the official approved brand artwork — render it exactly as supplied.
 *
 * Props
 *   width      — desired rendered width in px (height is computed from 500:548 aspect ratio)
 *   className  — optional CSS class string
 *   style      — optional inline style overrides
 */

interface WorkRoamerBrandProps {
  width?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export default function WorkRoamerBrand({
  width = 280,
  className,
  style,
}: WorkRoamerBrandProps) {
  return (
    <img
      src="/workroamer-brand.png"
      alt="WorkRoamer™ — Where work finds you"
      width={typeof width === 'number' ? width : undefined}
      className={className}
      style={{
        width,
        height: 'auto',
        display: 'block',
        // RC-MOBILE: maxWidth ensures the brand never overflows its container on
        // narrow viewports. Without this, a 300px brand inside a ~271px content
        // area (Login/Signup on 375px device) extends 29px beyond the card edge,
        // causing Chrome Mobile to auto-zoom the entire session viewport to fit.
        maxWidth: '100%',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
